import { FC } from "react";
import { cn } from "@/lib/utils";

interface BarProps {
  className?: string;
}

const Bar: FC<BarProps> = ({ className }) => (
  <div className={cn("bg-zinc-200 rounded animate-pulse", className)} />
);

interface Props {
  className?: string;
}

const InvoiceSkeleton: FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        "w-full min-h-[1000px] bg-white p-12 overflow-hidden flex flex-col gap-10",
        className
      )}
    >
      <div className="flex justify-between items-start">
        <Bar className="h-8 w-56" />
        <Bar className="h-16 w-28 rounded-lg" />
      </div>

      <div className="flex justify-between gap-12">
        <div className="flex flex-col gap-2 flex-1">
          <Bar className="h-4 w-40" />
          <Bar className="h-4 w-48" />
          <Bar className="h-4 w-36" />
        </div>
        <div className="flex flex-col gap-2 flex-1 items-end">
          <Bar className="h-4 w-32" />
          <Bar className="h-4 w-40" />
        </div>
      </div>

      <div className="flex flex-col">
        <div className="grid grid-cols-12 gap-4 border-b-2 border-zinc-300 pb-3">
          <Bar className="h-4 col-span-7" />
          <Bar className="h-4 col-span-2" />
          <Bar className="h-4 col-span-3" />
        </div>
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="grid grid-cols-12 gap-4 py-4 border-b border-zinc-100"
          >
            <Bar className="h-4 col-span-7" />
            <Bar className="h-4 col-span-2" />
            <Bar className="h-4 col-span-3" />
          </div>
        ))}
      </div>

      <div className="flex justify-end">
        <div className="flex justify-between border-t-2 border-zinc-300 pt-4 w-2/5">
          <Bar className="h-6 w-24" />
          <Bar className="h-6 w-32" />
        </div>
      </div>
    </div>
  );
};

export default InvoiceSkeleton;
